export class UserDetailsModel {
      compaVaNameEn:number ;
      defaultSecProId:number;
      empName:string;
      empyeeId:number;
      orgsmId:number;
      partnerid:number;
      partnername:string;
      prfileDescEn:string;
      secProId:number ;
      secSubProId:number ;
      secUsrId:number;
      secUsrLogin:string;
      staRecCode:string;
      subprofileDescEn:number;
}